import moment from "moment"

export function normalizeTimestamp(timestamp) {
  if (!timestamp && timestamp !== 0) {
    return null
  }

  if (moment.isMoment(timestamp)) {
    return timestamp
  }

  if (typeof timestamp === "string") {
    return moment(parseInt(timestamp, 10))
  }

  return moment(timestamp)
}
